import { render, staticRenderFns } from "./CodeHistoryTable.vue?vue&type=template&id=a5d47682"
import script from "./CodeHistoryTable.vue?vue&type=script&lang=js"
export * from "./CodeHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports